import axios from 'axios'
import { jwtDecode } from 'jwt-decode'
import { ApiServerUrl } from 'redux/config/services/Constants'
import {
  getStoredTokenExp,
  setStoredTokenExp,
  usesPersistentTokenStorage,
} from 'shared/auth/tokenStorage'

let refreshPromise: Promise<boolean> | null = null

function parseAccessExpiration(data: Record<string, unknown>): number | null {
  const accessExpiration = data.accessExpiration ?? data.access_expiration
  if (typeof accessExpiration === 'string') {
    return Math.floor(new Date(accessExpiration).getTime() / 1000)
  }

  const accessToken = data.access
  if (typeof accessToken === 'string') {
    const decoded = jwtDecode(accessToken) as { exp?: number }
    return decoded.exp ?? null
  }

  return getStoredTokenExp()
}

export function isAuthRefreshUrl(url: string): boolean {
  return (
    url.includes('/auth/login/') ||
    url.includes('/auth/token/refresh/') ||
    url.includes('/auth/logout/')
  )
}

export async function refreshAccessToken(): Promise<boolean> {
  if (refreshPromise) {
    return refreshPromise
  }

  refreshPromise = (async () => {
    try {
      const { data } = await axios.post(
        `${ApiServerUrl}/auth/token/refresh/`,
        {},
        { withCredentials: true }
      )

      const exp = parseAccessExpiration(data)
      if (!exp) {
        return false
      }

      setStoredTokenExp(exp, usesPersistentTokenStorage())
      return true
    } catch {
      return false
    } finally {
      refreshPromise = null
    }
  })()

  return refreshPromise
}
